// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/list_set_dressing_bank.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SetDressingReference } from "./set_dressing_reference_pb";
import { file_vision_assets_v1_set_dressing_reference } from "./set_dressing_reference_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/list_set_dressing_bank.proto.
 */
export const file_vision_assets_v1_list_set_dressing_bank: GenFile = /*@__PURE__*/
  fileDesc("Ci12aXNpb24vYXNzZXRzL3YxL2xpc3Rfc2V0X2RyZXNzaW5nX2JhbmsucHJvdG8SF3Byb3Rvcy52aXNpb24uYXNzZXRzLnYxIoYBChpMaXN0U2V0RHJlc3NpbmdCYW5rUmVxdWVzdBJKCgZwYXJhbXMYASABKAsyOi5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5MaXN0U2V0RHJlc3NpbmdCYW5rUmVxdWVzdC5QYXJhbXMaHAoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkitwEKG0xpc3RTZXREcmVzc2luZ0JhbmtSZXNwb25zZRJLCgZyZXN1bHQYASABKAsyOy5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5MaXN0U2V0RHJlc3NpbmdCYW5rUmVzcG9uc2UuUmVzdWx0GksKBlJlc3VsdBJBCgpyZWZlcmVuY2VzGAEgAygLMi0ucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuU2V0RHJlc3NpbmdSZWZlcmVuY2ViBnByb3RvMw", [file_vision_assets_v1_set_dressing_reference]);

/**
 * @generated from message protos.vision.assets.v1.ListSetDressingBankRequest
 */
export type ListSetDressingBankRequest = Message<"protos.vision.assets.v1.ListSetDressingBankRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ListSetDressingBankRequest.Params params = 1;
   */
  params?: ListSetDressingBankRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ListSetDressingBankRequest.
 * Use `create(ListSetDressingBankRequestSchema)` to create a new message.
 */
export const ListSetDressingBankRequestSchema: GenMessage<ListSetDressingBankRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_set_dressing_bank, 0);

/**
 * @generated from message protos.vision.assets.v1.ListSetDressingBankRequest.Params
 */
export type ListSetDressingBankRequest_Params = Message<"protos.vision.assets.v1.ListSetDressingBankRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.assets.v1.ListSetDressingBankRequest.Params.
 * Use `create(ListSetDressingBankRequest_ParamsSchema)` to create a new message.
 */
export const ListSetDressingBankRequest_ParamsSchema: GenMessage<ListSetDressingBankRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_set_dressing_bank, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.ListSetDressingBankResponse
 */
export type ListSetDressingBankResponse = Message<"protos.vision.assets.v1.ListSetDressingBankResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ListSetDressingBankResponse.Result result = 1;
   */
  result?: ListSetDressingBankResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ListSetDressingBankResponse.
 * Use `create(ListSetDressingBankResponseSchema)` to create a new message.
 */
export const ListSetDressingBankResponseSchema: GenMessage<ListSetDressingBankResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_set_dressing_bank, 1);

/**
 * @generated from message protos.vision.assets.v1.ListSetDressingBankResponse.Result
 */
export type ListSetDressingBankResponse_Result = Message<"protos.vision.assets.v1.ListSetDressingBankResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.assets.v1.SetDressingReference references = 1;
   */
  references: SetDressingReference[];
};

/**
 * Describes the message protos.vision.assets.v1.ListSetDressingBankResponse.Result.
 * Use `create(ListSetDressingBankResponse_ResultSchema)` to create a new message.
 */
export const ListSetDressingBankResponse_ResultSchema: GenMessage<ListSetDressingBankResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_set_dressing_bank, 1, 0);

